<script setup lang="ts">
  /**
   * PortalGamesList — lego-land's presentational GamesList plus the
   * platform's game-click analytics.
   *
   * Layout configs carry data only (they are structuredClone'd), so a
   * tracking callback cannot be passed as a prop. This is the same pattern
   * AdSlot and PortalFeedAd use: the smart wrapper lives in common and is
   * contributed to lego-land's component registry at boot.
   */
  import GamesList from '../../../lego-land/components/organisms/GamesList/GamesList.vue'
  import type { GamesListItem } from '../../../lego-land/components/organisms/GamesList/types'
  import { useAnalytics } from '../../composables/analytics/useAnalytics'
  import { userEngagementStore } from '../../store/userData/UserEngagementStore'

  defineProps<{
    heading?: string
    items?: GamesListItem[]
  }>()

  const { track } = useAnalytics()
  const userEngagement = userEngagementStore()

  /**
   * Same event name and engagement signal the classic GameCard fires, so
   * portal game clicks land in the existing reports. The anchor keeps its
   * native navigation (no preventDefault), so nothing here can be blocked
   * as a popup or swallow the click.
   */
  function handleSelect(item: GamesListItem) {
    userEngagement.engage('game')
    track('GameTile_Clicked', {
      ntp_game_url: item.href ?? '',
      ntp_game_image: item.imageUrl,
      ntp_content_type: 'game',
      // Which portal module the click came from — the strip's game card
      // fires the same event tagged 'strip', so the two are separable
      ntp_game_source: 'popular_games',
    })
  }
</script>

<template>
  <GamesList :heading="heading" :items="items" @select="handleSelect" />
</template>
